module.exports = __webpack_public_path__ + "static/img/banner.ce3f0d51.jpg";